import type { TrackingConsentLocale } from './types';

const locale: TrackingConsentLocale = {
  copy: {
    title: 'Ми використовуємо файли cookie',
    description:
      'Ми використовуємо файли cookie та подібні технології для роботи цього сервісу. Суворо необхідні файли cookie завжди активні.',
    allow_label: 'Прийняти всі файли cookie',
    reject_label: 'Лише суворо необхідні',
    settings_label: 'Налаштування файлів cookie',
    policy_link_label: 'Політика конфіденційності та файлів cookie',
    categories_label: 'Категорії',
    always_on_label: 'Завжди активні',
    required_label: "Обов'язково",
    save_preferences_label: 'Зберегти налаштування',
    close_label: 'Закрити',
    allow_all_optional_categories_label: "Дозволити всі необов'язкові категорії",
    settings_title: 'Налаштування файлів cookie',
    settings_description:
      'Ми використовуємо файли cookie та подібні технології для роботи цього сервісу. Суворо необхідні файли cookie завжди активні.',
    save_error: 'Не вдалося зберегти ваш вибір щодо конфіденційності. Спробуйте ще раз.'
  },
  categories: {
    strictly_necessary: {
      name: 'Суворо необхідні',
      purpose: 'Потрібні для роботи цього сервісу, і їх не можна вимкнути.'
    },
    analytics: {
      name: 'Аналітика',
      purpose: 'Вимірюють, як відвідувачі користуються цим сервісом, щоб покращити його роботу.'
    },
    marketing: { name: 'Маркетинг', purpose: 'Підтримують рекламу та маркетинг, обрані організатором.' }
  }
};

export default locale;
